export default __webpack_public_path__ + "static/slide4-c6a47a0851223ac27d49262168a41251.webp";